export default {
    MEDIA_AUDIO: 1,
    MEDIA_VEDIO: 2,
};
